import { config } from "./config-YCVVL8rs.js";

//#region src/config/env-prd.ts
config.initialize("prd");
config.set((conf) => {
	conf.urls = {
		...conf.urls,
		apiGateway: "https://api.jwplayer.com",
		contentServer: "https://cdn.jwplayer.com"
	};
});

//#endregion
//# sourceMappingURL=env-prd-B32-uqHw.js.map